




















































import { Prop, Component, Vue } from "vue-property-decorator";
import { SubTask } from "@/models/sub-task";

@Component({
  model: {
    prop: "tasks",
    event: "change"
  }
})
export default class VTaskSubtaskControl extends Vue {
  @Prop({ default: () => [] }) tasks!: SubTask[];

  appendTask() {
    this.$emit("change", [...this.tasks, new SubTask()]);
  }

  changeTask(task: SubTask, i: number) {
    this.$emit("change", [
      ...this.tasks.slice(0, i),
      task,
      ...this.tasks.slice(i + 1)
    ]);
  }

  changeTaskName(task: SubTask, name: string, i: number) {
    this.changeTask({ ...task, name }, i);
  }

  changeTaskDueDate(task: SubTask, dueDate: string, i: number) {
    this.changeTask({ ...task, dueDate }, i);
  }

  removeTask(i: number) {
    this.$emit("change", [
      ...this.tasks.slice(0, i),
      ...this.tasks.slice(i + 1)
    ]);
  }

  public focus() {
    const names = this.$refs.names as HTMLElement[];
    if (names.length > 0) {
      names[0].focus();
    }
  }
}
